// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "styles" + "." + "e04a988c300b05c20add" + ".css";
};